import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaLink, FaGithub } from "react-icons/fa";
import craft from './../../img/Portfolio/woodcraft.png'
import medicare from './../../img/Portfolio/medicare.png'
import university from './../../img/Portfolio/university.png'

const RecentProj = () => {
    return (
        <Container className="my-5">
            <h2 className="fw-bold py-3">Recent Project</h2>
            <Row className="py-3">
                <Col md={5}><img src={craft} alt="" /></Col>
                <Col md={7}>
                    <h3>Wooden Craft</h3>
                    <h4>Features</h4>
                    <p>
                        This is wooden craft website<br />
                        User can Registration this site<br />
                        Login user got a dashboard panel<br />
                        Customer can see there order and gives review<br />
                        admin can upload, manage products and orders<br />
                    </p>
                    <p>
                        <span>Live Link</span><a href="https://craft-mh.web.app/" target="blank"><FaLink /></a>
                        <span className="ps-3">Client Link</span><a href="https://github.com/md-mh/craft-client" target="blank"><FaGithub /></a>
                        <span className="ps-3">Server Link</span><a href="https://github.com/md-mh/craft-server" target="blank"><FaGithub /></a>

                    </p>
                </Col>
            </Row>
            <Row className="py-3">
                <Col md={7}>
                    <h3>Medicare</h3>
                    <h4>Features</h4>
                    <p>
                        This is a medical website<br />
                        People take there health service<br />
                        There are more talented doctors<br />
                        Using this site appointment medical service<br />
                        There have more patient review<br />
                        webpage Footer area have there social link for connet them<br />
                    </p>
                    <p>
                        <span>Live Link</span><a href="https://medicare-mh.web.app/" target="blank"><FaLink /></a>
                        <span className="ps-3">Github Link</span><a href="https://github.com/md-mh/medicare" target="blank"><FaGithub /></a>
                    </p>
                </Col>
                <Col md={5}><img src={medicare} alt="" /></Col>
            </Row>
            <Row className="py-3">
                <Col md={5}><img src={university} alt="" /></Col>
                <Col md={7}>
                    <h3>University Website</h3>
                    <h4>Features</h4>
                    <p>
                        This is a university website<br />
                        This is is help students known about university of michigan<br />
                        Students known about multiple services in this university<br />
                        There have a contact form where uses for contact with university easily<br />
                        People about this university<br />
                    </p>
                    <p>
                        <span>Live Link</span><a href="https://university-mh.netlify.app/" target="blank"><FaLink /></a>
                        <span className="ps-3">Github Link</span><a href="https://github.com/md-mh/university" target="blank"><FaGithub /></a>
                    </p>
                </Col>
            </Row>
        </Container >
    );
};

export default RecentProj;